import { Module } from 'wrapper6'
import Swiper from 'swiper/bundle'
import { debounce } from '../utils/_debounce'
import Lightbox from '../utils/_lightbox'

const $ = jQuery

export default class GallerySliders extends Module {
  	ready (app) {
    const GALLERY_SLIDERS = document.querySelectorAll('.single-gallery')
    if (GALLERY_SLIDERS.length > 0) {
      for (let i = 0; i < GALLERY_SLIDERS.length; i++) {
        const GALLERY_SLIDER = new GallerySlider(GALLERY_SLIDERS[i])
      }
    }
  }
}

class GallerySlider {
  constructor (CONTAINER) {
    this.CONTAINER = CONTAINER
    this.SWIPER_CONTAINER = this.CONTAINER.querySelector('.swiper-container')

    this.SWIPER = new Swiper(this.SWIPER_CONTAINER, {
      slidesPerView: 1.1,
      speed: 800,
      spaceBetween: 24,
      freeMode: false,
      watchOverflow: true,
      slidesOffsetAfter: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        401: {
          slidesPerView: 1.2
        },
        1001: {
          slidesPerView: 1.6
        }
      }
    })

    this.updateSlidesOffset()
    this.SWIPER.on('resize', debounce(() => this.updateSlidesOffset(), 300))

    // create lightbox
    const lightBox = new Lightbox('.single-gallery-slide__expand')
  }

  // calculate slidesOffsetAfter for swiper
  updateSlidesOffset () {
    // get elements
    const GALLERY_CONTAINER = this.CONTAINER.querySelector('.single-gallery__slider .page_container')
    const LAST_SLIDE = this.CONTAINER.querySelector('.single-gallery__slider .last-slide')

    let slidesOffsetAfter = 0

    if (GALLERY_CONTAINER && LAST_SLIDE) {
      // get widths
      const GALLERY_CONTAINER_WIDTH = GALLERY_CONTAINER.getBoundingClientRect().width
      const LAST_SLIDE_WIDTH = LAST_SLIDE.getBoundingClientRect().width

      // calculate offset
      slidesOffsetAfter = GALLERY_CONTAINER_WIDTH - LAST_SLIDE_WIDTH

      // set offset and update
      this.SWIPER.params.slidesOffsetAfter = slidesOffsetAfter
      this.SWIPER.params.initialSlide = 0
      this.SWIPER.update()
    }
  }
}
